import type { BuyerIntent, MerchantQuote, PrepareResponse } from "../types.js";
import { evaluateQuote, normalizeIntent } from "./policy.js";
import { createProofBundle } from "./proof.js";

export const SAMPLE_INSTRUCTION =
  "Pay no more than KES 1,650 for two solar lanterns. Require the merchant to hand over a pickup code.";

export const SAMPLE_QUOTE: MerchantQuote = {
  quoteId: "quote-20260728-amina-001",
  merchantName: "Amina Solar Kiosk",
  merchantAddress: "0x1111111111111111111111111111111111111111",
  item: "solar lantern",
  quantity: 2,
  localCurrency: "KES",
  localAmount: 1600,
  stableSymbol: "USDm",
  stableAmount: 12.4,
  rate: 129.03,
  expiresAt: new Date(Date.now() + 15 * 60_000).toISOString(),
  fulfillment: "Merchant must reveal a pickup code and mark handover in PactTill.",
};

export function makeFreshSampleQuote(): MerchantQuote {
  return {
    ...SAMPLE_QUOTE,
    expiresAt: new Date(Date.now() + 15 * 60_000).toISOString(),
  };
}

export async function createSamplePrepareResponse(): Promise<PrepareResponse> {
  const quote = makeFreshSampleQuote();
  const intent: BuyerIntent = normalizeIntent(
    {
      expectedItem: "solar lantern",
      quantity: 2,
      maxLocalAmount: 1650,
      localCurrency: "KES",
      requireFulfillmentProof: true,
      confidence: 0.96,
    },
    SAMPLE_INSTRUCTION,
  );
  const decision = await evaluateQuote(intent, quote);
  const proof = await createProofBundle(quote, intent, decision);
  return {
    intent,
    decision,
    proof,
    extraction: {
      mode: "deterministic-fallback",
      model: "sample-fixture",
    },
  };
}

